import React, { ReactNode } from 'react';
import styles from './modal.module.scss';

import { IoCloseOutline } from 'react-icons/io5';
interface IModal {
  opened: boolean;
  openModal: (m: boolean) => void;
  children: ReactNode;
  onSubmit?: any;
}
const CModal = (props: IModal) => {
  return props.opened ? (
    <div className={styles.wrapper}>
      <div className={styles.modalBody}>
        <div className={styles.close} onClick={() => props.openModal(false)}>
          <IoCloseOutline />
        </div>
        {props.children}
      </div>
    </div>
  ) : null;
};

export default CModal;
